export const SIDEBAR_TOGGLE_STATE_KEY = 'SIDEBAR_TOGGLE_STATE'
